export default __webpack_public_path__ + "static/media/VN.b88ba594.webp";